import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 603px;
  height: 700px;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  display: flex;
  flex-direction: column;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  & span {
    display: inline-flex;
  }
`;

export const TitleText = styled.p`
  color: #1b203a;
  font-size: 18px;
  font-weight: 600;
  margin: unset;
`;

export const Close = styled.div`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const TextsRowFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  margin-top: 28px;
`;

export const TextsRowFlexItem = styled.div``;

export const TextTitle = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #474d66;
`;

export const TextDescription = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #d14343;
  margin-top: 4px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ManufacturerStatus = styled.div``;

export const ToolTipText = styled.p`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  margin: unset;
`;

export const Label = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #474d66;
  margin-top: 24px;
  margin-bottom: 8px;

  & span {
    color: #696f8c;
    font-weight: 500;
    font-size: 12px;
  }
`;

export const SuggestionsCheckBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 8px;
`;

export const CheckContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

interface ICheckbox {
  active: boolean;
}

export const Checkbox = styled.div<ICheckbox>`
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: 8px;
  border: ${({ active }) =>
    active ? '4px solid #1371fe' : '1px solid #d8dae5'};
  background-color: #fff;
  transition: 0.2s;
`;

export const CheckText = styled.div`
  margin-left: 12px;
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const HorizontalDivider = styled.hr`
  border: 0.5px solid #e6e8f0;
  margin-top: 24px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  padding: 10px 12px 10px 16px;
  min-height: 42px;
  background: transparent;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  margin-bottom: 16px;

  & span {
    display: inline-flex;
    cursor: pointer;
  }
`;

export const Input = styled.input`
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
  outline: none;
  border: none;
`;

export const SearchedManufacturersCheckBoxes = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 16px;
`;

export const LineContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  width: 100%;
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

export const ConfirmText = styled.p`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  margin: unset;
  cursor: pointer;
`;

export const Quote = styled.q``;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  height: 36px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#1371FE')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const Cancel = styled.button`
  height: 36px;
  padding: 0 16px;
  color: #474d66;
  background-color: transparent;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const DividerKeep = styled.div`
  height: 16px;
`;
